class UserNotLoggedInException {
  constructor() {
    window.console.error('not logged in');
  }
}

export default UserNotLoggedInException;
